import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { ViewJobComponent } from './components/view-job/view-job.component';
import { DeleteJobComponent } from './components/delete-job/delete-job.component';
import { JobFilterComponent } from './components/job-filter/job-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { SearchJobsComponent } from './components/search-jobs/search-jobs.component';
import { ApplyJobComponent } from './components/apply-job/apply-job.component';
import { AuthGuard } from '../shared/guards/auth.guard';
import { ListJobsComponent } from './components/list-jobs/list-jobs.component';
import { ListJobDetailsComponent } from './components/list-job-details/list-job-details.component';
import { JobNotesComponent } from './components/job-notes/job-notes.component';
import { LatestJobsComponent } from './components/latest-jobs/latest-jobs.component';
import { AdvanceJobFilterComponent } from './components/advance-job-filter/advance-job-filter.component';
import { SendProposalComponent } from './components/send-proposal/send-proposal/send-proposal.component';
import { MessagesModule } from '../messages/messages.module';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { JobsCarouselComponent } from './components/jobs-carousel/jobs-carousel.component';

const routes: Routes = [
  { path: 'view-job/:jobId/:navigatedfrom', component: ViewJobComponent },
  { path: 'delete-job-modal', component: DeleteJobComponent },
  { path: 'search-jobs', component: SearchJobsComponent },
  {
    path: 'apply-job/:jobId',
    component: ApplyJobComponent,
    canActivate: [AuthGuard],
  },
  { path: 'send-proposal/:jobId', component: SendProposalComponent },
];

@NgModule({
  declarations: [ViewJobComponent, DeleteJobComponent, JobFilterComponent, SearchJobsComponent, ApplyJobComponent, ListJobsComponent, ListJobDetailsComponent, JobNotesComponent, LatestJobsComponent, AdvanceJobFilterComponent, SendProposalComponent, JobsCarouselComponent],
  imports: [
    RouterModule.forChild(routes),
    NgbModule,
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    MessagesModule,
    CarouselModule
  ],
  exports: [
    ViewJobComponent,
    ListJobsComponent,
    JobFilterComponent,
    LatestJobsComponent,
    AdvanceJobFilterComponent
  ]
})
export class JobsModule { }
